import * as actionTypes from './actionsTypes';

export const setLoaderLayOver = (state) => {

  return {
    type: actionTypes.SETLOADERLAYOVER,
    data: state,
  };
};
